import CryptoJS from 'crypto-js'

// 固定加密
class FixedEncryption {
    constructor(password, fixedIV = "1234") {
        this.password = password;
        this.fixedIV = CryptoJS.enc.Utf8.parse(fixedIV);
    }
    
    // 加密（每次结果相同）
    encrypt(message) {
        return CryptoJS.AES.encrypt(message, this.password, {
            iv: this.fixedIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).toString();
    }
    
    // 解密
    decrypt(ciphertext) {
        const bytes = CryptoJS.AES.decrypt(ciphertext, this.password, {
            iv: this.fixedIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return bytes.toString(CryptoJS.enc.Utf8);
    }
}

export default FixedEncryption;